<div class="bw">
  <header id="tour-hs-header" class="bw__header">
    <div class="bw__title-row">
      <h1>Hosted summary</h1>
      <button
        pButton
        [text]="true"
        [rounded]="true"
        icon="pi pi-question-circle"
        pTooltip="Start tour"
        tooltipPosition="bottom"
        (click)="startTour()"
      ></button>
    </div>
  </header>

  <section class="bw__content">
    <app-domain-multiple-selector
      id="tour-hs-domain-selector"
      [domains]="domains"
      [label]="'Select the domains to retrieve the summary information'"
      [buttonLabel]="'Get summaries'"
      [panelCollapsed]="collapsed"
      [requesting]="requesting"
      (selectionChanged)="process($event)"
    >
    </app-domain-multiple-selector>

    <div *ngIf="domainSummaries" id="tour-hs-results" class="mt-2">
      <div *ngFor="let domainData of domainSummaries; let i = index" class="mb-2">
        <div class="text-align-end mb-2">
          <p-button
            icon="pi pi-download"
            [rounded]="true"
            [raised]="true"
            severity="info"
            size="large"
            pTooltip="Download summary information as CSV file"
            tooltipPosition="left"
            (onClick)="download()"
          ></p-button>
        </div>
        <p-panel header="Domain {{ domainData.domain }}">
          <div *ngFor="let record of domainData.summaries" class="mb-2">
            <span class="font-bold">{{ record.SERVICE_TYPE }}</span>
            <span class="ml-2">{{ record.QUANTITY }}</span>
          </div>

          <div class="mb-3">
            <div class="flex gap-2 align-items-center flex-wrap">
              <input
                type="text"
                pInputText
                [(ngModel)]="domainData.searchTerm"
                placeholder="Search..."
                (keyup.enter)="search(domainData)"
                class="flex-1"
              />
              <p-multiSelect
                [(ngModel)]="domainData.selectedFilterFields"
                [options]="availableFilterFields"
                placeholder="Filter by fields"
                [style]="{ width: '200px' }"
                optionLabel="label"
                optionValue="value"
                [showClear]="true"
                (onChange)="applyFilters(domainData)"
              ></p-multiSelect>
              <p-button
                label="Search"
                icon="pi pi-search"
                (onClick)="search(domainData)"
              ></p-button>
              <p-button
                label="Clear"
                icon="pi pi-times"
                severity="secondary"
                (onClick)="clearSearch(domainData)"
              ></p-button>
              <p-button
                type="button"
                icon="pi pi-cog"
                label="Columns"
                severity="success"
                (onClick)="colConfigOverlay.toggle($event)"
                pTooltip="Toggle columns"
              ></p-button>
              <p-overlayPanel #colConfigOverlay>
                <div class="flex flex-column gap-2" style="min-width: 200px">
                  <div class="font-semibold mb-2">Toggle Columns</div>
                  <div
                    *ngFor="let column of columns"
                    class="flex align-items-center gap-2"
                  >
                    <p-checkbox
                      [binary]="true"
                      [(ngModel)]="domainData.columnVisibility[column.key]"
                      [inputId]="'col-' + domainData.domain + '-' + column.key"
                    ></p-checkbox>
                    <label [for]="'col-' + domainData.domain + '-' + column.key" class="cursor-pointer">
                      {{ column.label }}
                    </label>
                  </div>
                </div>
              </p-overlayPanel>
            </div>
          </div>

          <p-table
            [value]="domainData.filteredRecords"
            [paginator]="true"
            [rows]="20"
            [rowsPerPageOptions]="[10, 20, 50, 100]"
            styleClass="p-datatable-striped"
          >
            <ng-template pTemplate="header">
              <tr>
                <th *ngIf="isColumnVisible(domainData, 'SITE')" class="w-3" pSortableColumn="SITE">
                  Site
                  <p-sortIcon field="SITE" />
                </th>
                <th *ngIf="isColumnVisible(domainData, 'SCOPE')" class="w-3" pSortableColumn="SCOPE">
                  Scope
                  <p-sortIcon field="SCOPE" />
                </th>
                <th *ngIf="isColumnVisible(domainData, 'SERVICE_TYPE')" class="w-3" pSortableColumn="SERVICE_TYPE">
                  Service type
                  <p-sortIcon field="SERVICE_TYPE" />
                </th>
                <th *ngIf="isColumnVisible(domainData, 'QUANTITY')" class="w-3" pSortableColumn="QUANTITY">
                  Quantity
                  <p-sortIcon field="QUANTITY" />
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-record>
              <tr>
                <td *ngIf="isColumnVisible(domainData, 'SITE')">{{ record.SITE }}</td>
                <td *ngIf="isColumnVisible(domainData, 'SCOPE')">{{ record.SCOPE }}</td>
                <td *ngIf="isColumnVisible(domainData, 'SERVICE_TYPE')">{{ record.SERVICE_TYPE }}</td>
                <td *ngIf="isColumnVisible(domainData, 'QUANTITY')">{{ record.QUANTITY }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="getVisibleColumnsCount(domainData)">No records found</td>
              </tr>
            </ng-template>
          </p-table>
        </p-panel>
      </div>
    </div>
  </section>
</div>
